import React from "react";

import { AttributeComponent } from "UI/UI.React/frames/components";
import { LinkAttribute } from "../LinkAttribute/LinkAttribute";

/** Komponenta, která vykresluje hodnotu atributu jako text nebo odkaz, v závislosti na tom, zda je hodnota url adresa */
export const LiteListFrameLinkAttributeComponent: AttributeComponent = ({
    record,
    attributeName,
}) => {
    return <LinkAttribute value={record?.[attributeName].value} />;
};
